import { Vector3 } from 'three';
import type { Flight } from '../universe/Flight';

export const DISPLAY_WIDTH = 1664, DISPLAY_HEIGHT = 320;

/** A single embedded flight display. Every prominent reading is live telemetry. */
export function drawFlightDisplay(c: CanvasRenderingContext2D, flight: Flight) {
  const w = DISPLAY_WIDTH, h = DISPLAY_HEIGHT;
  const forward = new Vector3(0, 0, -1).applyQuaternion(flight.rotation);
  const heading = (Math.atan2(forward.x, -forward.z) * 180 / Math.PI + 360) % 360;
  const pitch = Math.asin(Math.max(-1, Math.min(1, forward.y))) * 180 / Math.PI;
  const mode = flight.mode === 'orbit' ? '环绕欣赏' : flight.mode === 'cruise' ? '引导航行' : '自由航行';
  c.setTransform(1, 0, 0, 1, 0, 0);
  const background = c.createLinearGradient(0, 0, 0, h);
  background.addColorStop(0, '#10242c'); background.addColorStop(.34, '#08171d'); background.addColorStop(1, '#071116');
  c.fillStyle = background; c.fillRect(0, 0, w, h);
  c.strokeStyle = '#2a444c'; c.lineWidth = 2;
  c.beginPath(); c.moveTo(26, 61); c.lineTo(w - 26, 61); c.moveTo(26, 267); c.lineTo(w - 26, 267); c.stroke();
  for (const x of [410, w - 422]) { c.beginPath(); c.moveTo(x, 80); c.lineTo(x, 246); c.stroke(); }
  c.fillStyle = '#a4bec1'; c.font = '32px sans-serif'; c.textAlign = 'left';
  c.fillText('相对航速', 28, 42); c.fillText('航向', w - 392, 42);
  c.font = '23px sans-serif'; c.textAlign = 'center'; c.fillStyle = '#6b8d95'; c.fillText('曙光 / 深空勘探艇', w / 2, 39);
  c.textAlign = 'left'; c.fillStyle = '#e0e9df';
  const speed = String(Math.round(flight.speed)).padStart(3, '0');
  c.font = `${speed.length > 4 ? 98 : 132}px monospace`; c.fillText(speed, 25, 203);
  c.font = '125px monospace'; c.fillText(`${String(Math.round(heading)).padStart(3, '0')}°`, w - 402, 203);
  c.font = '25px sans-serif'; c.fillStyle = '#77999f';
  c.fillText(flight.speed < .5 ? '已停稳' : '正在航行', 32, 243);
  c.fillText(`俯仰 ${pitch >= 0 ? '+' : ''}${pitch.toFixed(1)}°`, w - 390, 243);
  // Wide attitude indicator with a pitch ladder and a small compass track.
  const cx = w / 2, cy = 166, r = 83, horizon = cy + Math.max(-70, Math.min(70, pitch * 1.7));
  c.save(); c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.clip();
  c.fillStyle = '#132d36'; c.fillRect(cx - r, cy - r, r * 2, r * 2);
  c.fillStyle = '#202c2c'; c.fillRect(cx - r, horizon, r * 2, r * 2);
  c.strokeStyle = '#86afb4'; c.lineWidth = 2;
  c.beginPath(); c.moveTo(cx - r, horizon); c.lineTo(cx + r, horizon); c.stroke();
  for (let i = -3; i <= 3; i++) if (i) {
    const half = Math.abs(i) % 2 ? 18 : 28;
    c.beginPath(); c.moveTo(cx - half, horizon + i * 21); c.lineTo(cx + half, horizon + i * 21); c.stroke();
  }
  c.restore(); c.strokeStyle = '#456d77'; c.lineWidth = 3; c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.stroke();
  c.strokeStyle = '#dcba7f'; c.lineWidth = 5; c.beginPath();
  c.moveTo(cx - 57, cy); c.lineTo(cx - 18, cy); c.lineTo(cx, cy + 8); c.lineTo(cx + 18, cy); c.lineTo(cx + 57, cy); c.stroke();
  c.font = '23px monospace'; c.fillStyle = '#8badb1'; c.textAlign = 'center';
  for (const [offset, x] of [[-30, cx - 246], [30, cx + 234]]) c.fillText(`${Math.round((heading + offset + 360) % 360)}°`, x, 171);
  for (const side of [-1, 1]) for (let i = 0; i < 7; i++) {
    c.strokeStyle = '#3c606b'; c.lineWidth = 2; c.beginPath();
    c.moveTo(cx + side * 147, 104 + i * 20); c.lineTo(cx + side * (i % 3 === 0 ? 169 : 158), 104 + i * 20); c.stroke();
  }
  c.font = '28px sans-serif'; c.fillStyle = '#b6cbc8'; c.textAlign = 'left'; c.fillText(`航速 ${Math.round(flight.speedLevel)}`, 29, 304);
  for (let i = 0; i < 6; i++) { c.fillStyle = i < Math.round(flight.speedLevel) ? '#8bbeb2' : '#233d45'; c.fillRect(180 + i * 22, 287, 13, 13); }
  c.fillStyle = '#8aadae'; c.textAlign = 'center'; c.fillText(flight.nearest.name, cx, 304);
  c.textAlign = 'right'; c.fillStyle = '#cbb28d'; c.fillText(mode, w - 30, 304); c.textAlign = 'left';
}
